import Convention from '@/generated/classes/Convention';
export default class ConventionExtend extends Convention {
  constructor() {
    super();
  }
}
